export const CELL_WIDTH = 90
export const COLOR_DARK_GREEN = "rgba(0,189,179, 1)"
export const COLOR_DARK_RED = " rgba(241,110,90, 1)"
